import React from "react";

import Home from "./views/home";

function Root() {
  return (
    <React.StrictMode>
      <Home />
    </React.StrictMode>
  );
}

export default Root;
